module.exports = __webpack_public_path__ + "img/comite.cf1ef5ff.svg";